<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col> </b-col>
        <b-col md="6" class="mx-auto">
          <b-card variant="light" class="p-1 logwrap">
            <div>
              <b-icon-arrow-left
                @click="$router.push('login')"
                font-scale="2"
                class="mr-3 back-button"
              ></b-icon-arrow-left>
            </div>
            <div v-if="!showstage2">
                <div
                  v-if="showsent == 'unsent'"
                  class="p-2 m-2 alert alert-danger sent-msg"
                >
                  {{ sentmsg }}
                </div>
              <div class="welc">
                <h3>Password Reset</h3>
                <h4>We need to Verify your Identity</h4>
              </div>
              <form @submit.prevent="fgPword">
                <b-form-group label="Email : " label-for="email">
                  <b-form-input
                    v-model="forgot.email"
                    type="email"
                    id="email"
                    class="loginp p-3"
                    placeholder="user@example.com"
                    required
                  >
                  </b-form-input>
                </b-form-group>
                <b-row>
                  <b-col md="3"></b-col>
                  <b-col md="6">
                    <b-overlay
                      :show="sending"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class=""
                    >
                      <b-button
                        :disabled="sending"
                        type="submit"
                        class="btn-md p-1 w-100"
                        variant="success"
                        >Get reset Token</b-button
                      >
                    </b-overlay>

                    <b-button
                      v-if="sending"
                      class="w-100 p-2 mt-3 btntxt"
                      variant="dark"
                      @click="stopproceed"
                    >
                      Cancel
                    </b-button>
                  </b-col>
                  <b-col md="3"></b-col>
                </b-row>
              </form>
            </div>

            <div v-if="showstage2">
              <div class="welc">
                <div
                  v-if="showsent == 'sent'"
                  class="p-2 m-2 alert alert-info sent-msg"
                >
                  {{ sentmsg }}
                </div>
                <h3>Password Reset</h3>
                <h4>Change to Your New Password</h4>
              </div>
              <form @submit.prevent="changePword">
                <div class="mb-4 mt-5">
                  <p>Enter OTP Token</p>
                  <vue-otp-2
                    length="6"
                    join-character="-"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    @onComplete="getOTP"
                  />
                </div>

                <b-form-group class="flabel" label-for="pword">
                  <span class="label">Enter New Password</span>
                  <b-input-group v-if="showStar == true">
                    <b-form-input
                      v-model="change.password"
                      type="password"
                      id="pword"
                      class="loginp p-3"
                      placeholder="***********"
                      required
                    >
                    </b-form-input>
                    <b-icon-eye-fill
                      font-scale="1.5"
                      class="close-button"
                      @click="
                        showText = true;
                        showStar = false;
                      "
                      variant="secondary"
                    ></b-icon-eye-fill>
                  </b-input-group>

                  <b-input-group v-if="showText == true">
                    <b-form-input
                      v-model="change.password"
                      type="text"
                      id="pword"
                      class="loginp p-3"
                      placeholder=""
                      required
                    >
                    </b-form-input>
                    <b-icon-eye-slash-fill
                      font-scale="1.5"
                      class="close-button"
                      @click="
                        showText = false;
                        showStar = true;
                      "
                      variant="secondary"
                    ></b-icon-eye-slash-fill>
                  </b-input-group>
                </b-form-group>

                <b-form-group class="flabel" label-for="cpword">
                  <span class="label">Confirm New Password</span>
                  <b-input-group v-if="showStar2 == true">
                    <b-form-input
                      v-model="change.cpword"
                      type="password"
                      id="cpword"
                      class="loginp p-3"
                      placeholder="***********"
                      required
                      @input="confirmpword()"
                    >
                    </b-form-input>
                    <b-icon-eye-fill
                      font-scale="1.5"
                      class="close-button"
                      @click="
                        showText2 = true;
                        showStar2 = false;
                      "
                      variant="secondary"
                    ></b-icon-eye-fill>
                  </b-input-group>

                  <b-input-group v-if="showText2 == true">
                    <b-form-input
                      v-model="change.cpword"
                      type="text"
                      id="cpword"
                      class="loginp p-3"
                      placeholder=""
                      required
                      @input="confirmpword()"
                    >
                    </b-form-input>
                    <b-icon-eye-slash-fill
                      font-scale="1.5"
                      class="close-button"
                      @click="
                        showText2 = false;
                        showStar2 = true;
                      "
                      variant="secondary"
                    ></b-icon-eye-slash-fill>
                  </b-input-group>
                </b-form-group>

                <div class="alert-danger mb-2" v-html="pworderr"></div>

                <div
                  v-if="reseterr == 'failed'"
                  class="p-2 m-2 alert alert-danger sent-msg"
                >
                  {{ resetmsg }}
                </div>

                <div
                  v-if="reseterr == 'expired'"
                  class="p-2 m-2 alert alert-info sent-msg"
                >
                  Your Request Token has expired. Request a new one.
                </div>
                <b-button
                  v-if="reseterr == 'expired'"
                  :to="{ name: 'forgot' }"
                  class="btn-md p-1 w-100"
                  variant="warning"
                  >Request Token</b-button
                >

                <div
                  v-if="reseterr == 'reset'"
                  class="p-2 m-2 alert alert-success sent-msg"
                >
                  Your Account's Password has been changed successfully
                </div>

                <b-row>
                  <b-col md="3"></b-col>
                  <b-col md="6">
                    <b-overlay
                      :show="resetting"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class=""
                    >
                      <b-button
                        v-if="reseterr != 'expired' && reseterr != 'reset'"
                        :disabled="chkfields"
                        type="submit"
                        class="btn-md p-1 w-100"
                        variant="success"
                        >Set New Password</b-button
                      >
                    </b-overlay>

                    <b-button
                      v-if="resetting"
                      class="w-100 p-2 mt-3 btntxt"
                      variant="dark"
                      @click="stopproceed2"
                    >
                      Cancel
                    </b-button>
                  </b-col>
                  <b-col md="3"></b-col>
                </b-row>
              </form>
            </div>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
//import NProgress from "nprogress";

export default {
  data() {
    return {
      forgot: this.createForgot(),
      change: this.createChange(),
      sending: false,
      showsent: "",
      countdown: 5,
      logginin: false,
      frompath: "",
      cmsg: "",
      confirmed: false,
      sentmsg: "",
      cpword: "",
      erronpword: true,
      pworderr: "",
      resetting: false,
      reseterr: "",
      resetmsg: "",
      showStar: true,
      showText: false,
      showStar2: true,
      showText2: false,
      showstage2: false
    };
  },
  beforeRouteEnter(to, from, next) {
    // NProgress.start();
    //alert(from.name)
    store.dispatch("loginmaster/setOrigin");
    //alert(from.fullPath)

    next(vm => {
      if (vm.loggedin) {
        vm.$router.push({
          name: "landing"
        });
      }
    });

    next();
    //NProgress.done();
  },
  created() {
    let now = new Date();
    now.setFullYear(now.getFullYear() - 10);
    document.cookie = `remember=;expires=${now.toUTCString()}`;
    document.cookie = `qid=;expires=${now.toUTCString()}`;

    this.sending = false;
  },

  updated() {},
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config,
      error: state => state.loginmaster.error,
      errmsg: state => state.loginmaster.errmsg,
      origin: state => state.loginmaster.site_origin
    }),

    chkfields() {
      if (
        this.change.email.length <= 0 ||
        this.change.rtoken.length <= 0 ||
        this.change.password.length <= 0 ||
        this.change.cpword.length <= 0 ||
        this.erronpword == true
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async fgPword() {
      const isNativePlatform = Capacitor.isNativePlatform();

      const appInfo = isNativePlatform ? await App.getInfo() : {};
      const appVersion = appInfo.version;

      this.forgot.channel = isNativePlatform ? "app" : "web";
      this.forgot.version = isNativePlatform
        ? appVersion
        : process.env.VUE_APP_CURRENT_VERSION;

      this.setloader();
      this.forgot.origin = this.origin;
      //NProgress.start();
      return this.$store
        .dispatch("loginmaster/forgotP", this.forgot)
        .then(response => {
          this.sending = false;
          this.showsent = response.sent;
          this.sentmsg = response.msg;
          this.showstage2 = response.sent == 'sent' ? true : false;
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk("Check your Network Connection. Could not Log in.", {
              title: "No Network Connection",
              size: "xs",
              centered: true
            })
            .then(() => {
              this.logginin = false;
            });
          //console.log(error);
        });
    },
    async changePword() {
      this.setloader2();

      //NProgress.start();
      return this.$store
        .dispatch("loginmaster/resetPword", this.change)
        .then(response => {
          this.resetting = false;
          this.reseterr = response.status;
          this.resetmsg = response.msg;

          this.change.rtoken = "";
          this.change.password = "";
          this.change.cpword = "";
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk("Check your Network Connection. Could not Log in.", {
              title: "No Network Connection",
              size: "xs",
              centered: true
            })
            .then(() => {
              this.logginin = false;
            });
          //console.log(error);
        });
    },
    confirmpword() {
      this.reseterr = "";
      let pword1 = this.change.password;
      let pword2 = this.change.cpword;

      if (pword1 != pword2) {
        this.pworderr = "<b class='p-2'>Passwords do not match</b>";
        this.erronpword = true;
      } else {
        this.pworderr = "";
        this.erronpword = false;
      }
    },
    getOTP(event) {
      this.change.rtoken = event.join("");
      this.change.email = this.forgot.email;
    },
    createForgot() {
      return {
        email: "",
        origin: "",
        channel: "",
        version: ""
      };
    },
    createChange() {
      return {
        password: "",
        cpword: "",
        email: "",
        rtoken: ""
      };
    },
    setloader() {
      this.sending = true;
    },
    setloader2() {
      this.resetting = true;
    },
    stopproceed() {
      this.logginin = false;
    },
    stopproceed2() {
      this.resetting = false;
    },
    ...mapActions("loginmaster", ["setErr", "forgotP"])
  }
};
</script>

<style lang="scss" scoped>
.logwrap {
  box-shadow: 5px 5px 15px grey;
  min-height: 500px;
}

.welc {
  text-align: center;
  font-size: 1.3rem;
}

p {
  text-align: left;
  font-size: 16px;
  padding: 5px;
}

.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.loginput {
  width: 300px;
  padding: 10px;
}

.flass {
  display: flex;
  align-items: center;
}

.btn-md {
  font-size: 18px;
  font-weight: bold;
  background-color: #00984a;
  color: white;
  cursor: pointer;
  border: 0px;
}

.logimg {
  width: 100%;
  height: 60vh;
}
.sent-msg {
  font-size: 1.2rem;
}
.close-button {
  position: relative;
  left: -40px;
  top: 10px;
  cursor: pointer;
  z-index: 9999;
}
.form-input {
  width: 97%;
}

.vue-otp-2 {
  display: flex;
  justify-content: space-between;

  div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    input {
      max-width: 80px;
      padding: 11.5px 8px;
      font-size: 20px;
      border-radius: 3px;
      border: 1px solid #cecece;
      text-align: center;
    }

    span {
      display: block;
      flex: 1;
      text-align: center; 
    }
  }
}
.back-button{
  cursor : pointer
}
</style>
